import Button from 'apollo-react/components/Button';
import Grid from 'apollo-react/components/Grid';
import Typography from 'apollo-react/components/Typography';
import { ChevronLeft, ChevronRight } from 'apollo-react-icons';
import Filter from 'apollo-react-icons/Filter';
import Refresh from 'apollo-react-icons/Refresh';
import React from 'react';
import { Navigate } from 'react-big-calendar';

import withTranslation from '../../../components/withTranslation';

function Toolbar({
  view,
  views,
  localizer,
  label,
  onShowFilter,
  onRefresh,
  onNavigate,
  onView,
  translateString,
}) {
  const { messages } = localizer;

  function viewNamesGroup(messages) {
    if (views.length > 1) {
      return views.map((name) => (
        <Button
          key={name}
          variant={view === name ? 'secondary' : 'text'}
          onClick={() => onView(name)}
          ui-ta={messages[name]}
        >
          {translateString(messages[name])}
        </Button>
      ));
    }
    return null;
  }

  return (
    <Grid
      container
      style={{ marginBottom: 16, justifyContent: 'space-between', display: 'flex' }}
      ui-ta="Calendar Toolbar"
    >
      <Grid item>
        <Button variant="text" onClick={() => onNavigate(Navigate.PREVIOUS)} ui-ta="Previous">
          <ChevronLeft fontSize="small" />
          {translateString(messages.previous)}
        </Button>
        <Button variant="text" onClick={() => onNavigate(Navigate.TODAY)} ui-ta="Today">
          {translateString(messages.today)}
        </Button>
        <Button variant="text" onClick={() => onNavigate(Navigate.NEXT)} ui-ta="Next">
          {translateString(messages.next)}
          <ChevronRight fontSize="small" />
        </Button>
        &nbsp; &nbsp; &nbsp;
        <Button variant="secondary" icon={Filter} onClick={onShowFilter} ui-ta="ShowFilter">
          {translateString('Show Filter')}
        </Button>
        &nbsp;
        <Button variant="secondary" icon={Refresh} onClick={onRefresh} ui-ta="Refresh">
          {translateString('Refresh')}
        </Button>
      </Grid>
      <Grid item style={{ display: 'flex', alignItems: 'center' }}>
        <Typography variant="title1" ui-ta="Title">
          {label}
        </Typography>
      </Grid>
      <Grid item ui-ta="Views">
        {viewNamesGroup(messages)}
      </Grid>
    </Grid>
  );
}

export default withTranslation(Toolbar);
